var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import FilterAltOutlinedIcon from "@mui/icons-material/FilterAltOutlined";
import { Button, Dropdown, Search, Typography, } from "@uigovpe/components";
import { useEffect, useMemo, useRef, useState, } from "react";
import { useSearchParams } from "react-router-dom";
import { getAgencies } from "../../../apis/agencies";
import { getConsultationById, getConsultations, } from "../../../apis/consultations";
import { getMyContributions } from "../../../apis/contributions";
import { getApiErrorMessage } from "../../../apis/http";
import { getThemes } from "../../../apis/themes";
import { useAuth } from "../../auth/AuthContext";
import { HearingsCatalogSection } from "../../hearings/pages/HearingsCatalogSection";
import { HomeTabButton } from "../../layout/HomeTabButton";
import { HomeConsultationCard } from "../components/HomeConsultationCard";
import { allowedPublicStatuses } from "../utils/participation";
var STATUS_TO_API = {
    Ativa: "active",
    Encerrada: "finished",
    Fechada: "closed",
    Publicada: "published",
};
var pageStyle = {
    margin: "0 auto",
    maxWidth: 1320,
    width: "100%",
};
var titleContainerStyle = {
    alignItems: "center",
    display: "flex",
    flexWrap: "wrap",
    gap: 16,
    justifyContent: "space-between",
    padding: "16px 0",
};
var filtersCardStyle = {
    border: "2px solid #CED2D7",
    borderRadius: 12,
    display: "grid",
    gap: 16,
    padding: 16,
};
var filtersHeaderStyle = {
    alignItems: "center",
    display: "flex",
    gap: 8,
};
var filtersGridStyle = {
    display: "grid",
    gap: 16,
    gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))",
};
var filtersActionsStyle = {
    alignItems: "center",
    display: "flex",
    gap: 12,
    justifyContent: "flex-end",
};
var tabsContainerStyle = {
    alignItems: "center",
    borderBottom: "1px solid #E5E7EB",
    display: "flex",
    gap: 24,
    marginBottom: 16,
    marginTop: 16,
    width: "100%",
};
var cardsGridStyle = {
    display: "grid",
    gap: 24,
    gridTemplateColumns: "repeat(auto-fill, minmax(280px, 1fr))",
    padding: "16px 0",
    width: "100%",
};
var emptyStateStyle = {
    color: "#6B7280",
    display: "flex",
    justifyContent: "center",
    padding: "40px 0",
    textAlign: "center",
};
var feedbackBoxBaseStyle = {
    borderRadius: 12,
    padding: "12px 16px",
};
var loadConsultationsByIds = function (ids, accessToken) { return __awaiter(void 0, void 0, Promise, function () {
    var results;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, Promise.all(ids.map(function (consultationId) { return __awaiter(void 0, void 0, void 0, function () {
                    var response;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0: return [4 /*yield*/, getConsultationById(consultationId, accessToken)];
                            case 1:
                                response = _a.sent();
                                return [2 /*return*/, response.data.consultation];
                        }
                    });
                }); }))];
            case 1:
                results = _a.sent();
                return [2 /*return*/, results.filter(Boolean)];
        }
    });
}); };
export var ConsultationsHomePage = function () {
    var _a = useAuth(), accessToken = _a.accessToken, role = _a.role;
    var _b = useSearchParams(), searchParams = _b[0], setSearchParams = _b[1];
    var isCitizenLogged = role === "citizen";
    var debounceRef = useRef(null);
    var mineCacheRef = useRef(new Map());
    var _c = useState("all"), tab = _c[0], setTab = _c[1];
    var _d = useState(function () {
        return searchParams.get("section") === "hearings" ? "hearings" : "consultations";
    }), contentTab = _d[0], setContentTab = _d[1];
    var _e = useState(""), search = _e[0], setSearch = _e[1];
    var _f = useState(""), debouncedSearch = _f[0], setDebouncedSearch = _f[1];
    var _g = useState("Todos"), orgao = _g[0], setOrgao = _g[1];
    var _h = useState("Todos"), tema = _h[0], setTema = _h[1];
    var _j = useState("Todos"), status = _j[0], setStatus = _j[1];
    var _k = useState(false), loading = _k[0], setLoading = _k[1];
    var _l = useState([]), consultationsAll = _l[0], setConsultationsAll = _l[1];
    var _m = useState([]), consultationsMineRaw = _m[0], setConsultationsMineRaw = _m[1];
    var _o = useState([]), themes = _o[0], setThemes = _o[1];
    var _p = useState(false), themesLoading = _p[0], setThemesLoading = _p[1];
    var _q = useState([]), agencies = _q[0], setAgencies = _q[1];
    var _r = useState(false), agenciesLoading = _r[0], setAgenciesLoading = _r[1];
    var _s = useState(null), error = _s[0], setError = _s[1];
    var orgaosOptions = useMemo(function () { return __spreadArray([
        { code: "Todos", name: "Órgãos" }
    ], agencies.map(function (agency) { return ({
        code: agency.id,
        name: agency.acronym.substring(0, 20),
    }); }), true); }, [agencies]);
    var temasOptions = useMemo(function () { return __spreadArray([
        { code: "Todos", name: "Temas" }
    ], themes.map(function (theme) { return ({
        code: theme.id,
        name: theme.name.substring(0, 20),
    }); }), true); }, [themes]);
    var statusOptions = useMemo(function () { return [
        { code: "Todos", name: "Status" },
        { code: "Ativa", name: "Ativa" },
        { code: "Fechada", name: "Fechada" },
        { code: "Encerrada", name: "Encerrada" },
        { code: "Publicada", name: "Publicada" },
    ]; }, []);
    var canClear = search.trim().length > 0 ||
        orgao !== "Todos" ||
        tema !== "Todos" ||
        status !== "Todos";
    useEffect(function () {
        if (searchParams.get("section") === "hearings") {
            setContentTab("hearings");
        }
    }, [searchParams]);
    var selectContentTab = function (nextTab) {
        setContentTab(nextTab);
        var nextParams = new URLSearchParams(searchParams);
        if (nextTab === "hearings") {
            nextParams.set("section", "hearings");
        }
        else {
            nextParams.delete("section");
            nextParams.delete("tab");
        }
        setSearchParams(nextParams, { replace: true });
    };
    useEffect(function () {
        if (debounceRef.current) {
            window.clearTimeout(debounceRef.current);
        }
        debounceRef.current = window.setTimeout(function () {
            setDebouncedSearch(search);
        }, 300);
        return function () {
            if (debounceRef.current) {
                window.clearTimeout(debounceRef.current);
            }
        };
    }, [search]);
    useEffect(function () {
        var isMounted = true;
        var loadFilters = function () { return __awaiter(void 0, void 0, void 0, function () {
            var _a, themesResponse, agenciesResponse, loadError_1;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 2, 3, 4]);
                        setThemesLoading(true);
                        setAgenciesLoading(true);
                        return [4 /*yield*/, Promise.all([
                                getThemes(),
                                getAgencies({ limit: 100, page: 0 }),
                            ])];
                    case 1:
                        _a = _b.sent(), themesResponse = _a[0], agenciesResponse = _a[1];
                        if (!isMounted) {
                            return [2 /*return*/];
                        }
                        setThemes(themesResponse.data.themes || []);
                        setAgencies(agenciesResponse.data.agencies || []);
                        return [3 /*break*/, 4];
                    case 2:
                        loadError_1 = _b.sent();
                        if (!isMounted) {
                            return [2 /*return*/];
                        }
                        setError(getApiErrorMessage(loadError_1));
                        return [3 /*break*/, 4];
                    case 3:
                        if (isMounted) {
                            setThemesLoading(false);
                            setAgenciesLoading(false);
                        }
                        return [7 /*endfinally*/];
                    case 4: return [2 /*return*/];
                }
            });
        }); };
        void loadFilters();
        return function () {
            isMounted = false;
        };
    }, []);
    useEffect(function () {
        if (!isCitizenLogged && tab === "mine") {
            setTab("all");
        }
    }, [isCitizenLogged, tab]);
    useEffect(function () {
        if (tab !== "all") {
            return;
        }
        var isMounted = true;
        var fetchAll = function () { return __awaiter(void 0, void 0, void 0, function () {
            var response, loadError_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        setLoading(true);
                        setError(null);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, 4, 5]);
                        return [4 /*yield*/, getConsultations({
                                agencyId: orgao !== "Todos" ? orgao || undefined : undefined,
                                direction: "DESC",
                                limit: 250,
                                page: 0,
                                status: status !== "Todos" ? STATUS_TO_API[status] : undefined,
                                themeId: tema !== "Todos" ? tema || undefined : undefined,
                                title: debouncedSearch.trim() || undefined,
                            }, accessToken)];
                    case 2:
                        response = _a.sent();
                        if (!isMounted) {
                            return [2 /*return*/];
                        }
                        setConsultationsAll((response.data.consultations || []).filter(function (consultation) {
                            return allowedPublicStatuses.includes(consultation.status);
                        }));
                        return [3 /*break*/, 5];
                    case 3:
                        loadError_2 = _a.sent();
                        if (!isMounted) {
                            return [2 /*return*/];
                        }
                        setError(getApiErrorMessage(loadError_2));
                        return [3 /*break*/, 5];
                    case 4:
                        if (isMounted) {
                            setLoading(false);
                        }
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        }); };
        void fetchAll();
        return function () {
            isMounted = false;
        };
    }, [accessToken, debouncedSearch, orgao, status, tab, tema]);
    useEffect(function () {
        if (tab !== "mine" || !accessToken || !isCitizenLogged) {
            if (tab !== "mine") {
                setError(null);
            }
            return;
        }
        var isMounted = true;
        var fetchMine = function () { return __awaiter(void 0, void 0, void 0, function () {
            var response, consultationIds, missingIds, missingConsultations, mineConsultations, loadError_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        setLoading(true);
                        setError(null);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 5, 6, 7]);
                        return [4 /*yield*/, getMyContributions(accessToken)];
                    case 2:
                        response = _a.sent();
                        consultationIds = Array.from(new Set((response.data.contributions || [])
                            .map(function (entry) { return entry.contribution.consultationId; })
                            .filter(function (consultationId) { return Number.isFinite(consultationId); })));
                        if (consultationIds.length === 0) {
                            if (isMounted) {
                                setConsultationsMineRaw([]);
                            }
                            return [2 /*return*/];
                        }
                        missingIds = consultationIds.filter(function (consultationId) { return !mineCacheRef.current.has(consultationId); });
                        if (!(missingIds.length > 0)) return [3 /*break*/, 4];
                        return [4 /*yield*/, loadConsultationsByIds(missingIds, accessToken)];
                    case 3:
                        missingConsultations = _a.sent();
                        missingConsultations.forEach(function (consultation) {
                            mineCacheRef.current.set(consultation.id, consultation);
                        });
                        _a.label = 4;
                    case 4:
                        if (!isMounted) {
                            return [2 /*return*/];
                        }
                        mineConsultations = consultationIds
                            .map(function (consultationId) { return mineCacheRef.current.get(consultationId); })
                            .filter(function (consultation) {
                            return Boolean(consultation);
                        })
                            .filter(function (consultation) {
                            return allowedPublicStatuses.includes(consultation.status);
                        });
                        setConsultationsMineRaw(mineConsultations);
                        return [3 /*break*/, 7];
                    case 5:
                        loadError_3 = _a.sent();
                        if (!isMounted) {
                            return [2 /*return*/];
                        }
                        setError(getApiErrorMessage(loadError_3));
                        return [3 /*break*/, 7];
                    case 6:
                        if (isMounted) {
                            setLoading(false);
                        }
                        return [7 /*endfinally*/];
                    case 7: return [2 /*return*/];
                }
            });
        }); };
        void fetchMine();
        return function () {
            isMounted = false;
        };
    }, [accessToken, isCitizenLogged, tab]);
    var consultationsMine = useMemo(function () {
        var normalizedQuery = debouncedSearch.trim().toLowerCase();
        return consultationsMineRaw.filter(function (consultation) {
            var _a, _b;
            if (normalizedQuery &&
                !String(consultation.title || "")
                    .toLowerCase()
                    .includes(normalizedQuery)) {
                return false;
            }
            if (tema !== "Todos" && typeof tema === "number") {
                if (((_a = consultation.theme) === null || _a === void 0 ? void 0 : _a.id) !== tema) {
                    return false;
                }
            }
            if (orgao !== "Todos" && typeof orgao === "number") {
                if (((_b = consultation.agency) === null || _b === void 0 ? void 0 : _b.id) !== orgao) {
                    return false;
                }
            }
            if (status !== "Todos" && consultation.status !== STATUS_TO_API[status]) {
                return false;
            }
            return true;
        });
    }, [consultationsMineRaw, debouncedSearch, orgao, status, tema]);
    var listToRender = tab === "mine" ? consultationsMine : consultationsAll;
    var resultsLabel = listToRender.length === 0
        ? "Nenhum resultado"
        : "".concat(listToRender.length, " resultado").concat(listToRender.length > 1 ? "s" : "");
    var clearAll = function () {
        setSearch("");
        setOrgao("Todos");
        setTema("Todos");
        setStatus("Todos");
    };
    function renderFeedback() {
        if (error) {
            return (_jsx("div", __assign({ style: __assign(__assign({}, feedbackBoxBaseStyle), { background: "#FFE4E4", color: "#7A1F1F" }) }, { children: _jsx(Typography, { children: error }) })));
        }
        if (!loading && listToRender.length === 0) {
            return (_jsx("div", __assign({ style: emptyStateStyle }, { children: _jsx(Typography, { children: tab === "mine" && isCitizenLogged
                        ? "Você ainda não possui contribuições."
                        : "Nada encontrado com os filtros atuais." }) })));
        }
        if (loading) {
            return (_jsx("div", __assign({ style: emptyStateStyle }, { children: _jsx(Typography, { children: "Carregando..." }) })));
        }
        return null;
    }
    var feedback = renderFeedback();
    return (_jsxs("div", __assign({ style: pageStyle }, { children: [_jsx("div", __assign({ style: titleContainerStyle }, { children: _jsx(Typography, __assign({ fontWeight: "bold", size: "lg" }, { children: contentTab === "consultations"
                        ? "Consultas Públicas Estaduais"
                        : "Audiências Públicas Estaduais" })) })), _jsxs("div", __assign({ style: tabsContainerStyle }, { children: [_jsx(HomeTabButton, { active: contentTab === "consultations", label: "Consultas", onClick: function () { return selectContentTab("consultations"); } }), _jsx(HomeTabButton, { active: contentTab === "hearings", label: "Audi\u00EAncias", onClick: function () { return selectContentTab("hearings"); } })] })), contentTab === "hearings" ? (_jsx(HearingsCatalogSection, {})) : (_jsxs(_Fragment, { children: [_jsxs("div", __assign({ style: filtersCardStyle }, { children: [_jsxs("div", __assign({ style: filtersHeaderStyle }, { children: [_jsx(FilterAltOutlinedIcon, { htmlColor: "#28272C" }), _jsx(Typography, __assign({ fontWeight: "bold" }, { children: "Filtrar consultas" }))] })), _jsxs("div", __assign({ style: filtersGridStyle }, { children: [_jsx(Search, { label: "", onChange: function (event) { var _a, _b; return setSearch((_b = (_a = event.target) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : ""); }, placeholder: "Buscar por t\u00EDtulo", showAutocomplete: false, value: search }), _jsx(Dropdown, { className: "w-full", disabled: agenciesLoading, onChange: function (event) { var _a; return setOrgao((_a = event.value) !== null && _a !== void 0 ? _a : "Todos"); }, optionLabel: "name", optionValue: "code", options: orgaosOptions, placeholder: agenciesLoading ? "Carregando..." : "Órgão", value: orgao }), _jsx(Dropdown, { className: "w-full", disabled: themesLoading, onChange: function (event) { var _a; return setTema((_a = event.value) !== null && _a !== void 0 ? _a : "Todos"); }, optionLabel: "name", optionValue: "code", options: temasOptions, placeholder: themesLoading ? "Carregando..." : "Tema", value: tema }), _jsx(Dropdown, { className: "w-full", onChange: function (event) {
                                            var _a;
                                            return setStatus((_a = event.value) !== null && _a !== void 0 ? _a : "Todos");
                                        }, optionLabel: "name", optionValue: "code", options: statusOptions, placeholder: "Status", value: status })] })), _jsxs("div", __assign({ style: filtersActionsStyle }, { children: [_jsx(Typography, __assign({ size: "xs" }, { children: loading || agenciesLoading || themesLoading
                                            ? "Carregando..."
                                            : resultsLabel })), _jsx(Button, { disabled: !canClear, label: "Limpar Filtros", link: true, onClick: clearAll, style: { fontSize: 12 } })] }))] })), isCitizenLogged ? (_jsxs("div", __assign({ style: tabsContainerStyle }, { children: [_jsx(HomeTabButton, { active: tab === "all", label: "Todas as contribui\u00E7\u00F5es", onClick: function () { return setTab("all"); } }), _jsx(HomeTabButton, { active: tab === "mine", label: "Minhas contribui\u00E7\u00F5es", onClick: function () { return setTab("mine"); } })] }))) : null, feedback ? (feedback) : (_jsx("div", __assign({ style: cardsGridStyle }, { children: listToRender.map(function (consultation) { return (_jsx(HomeConsultationCard, { consultation: consultation }, consultation.id)); }) })))] }))] })));
};
